(function () {
  const BLOCK = "trust-subscribe";
  const POPUP_VISIBLE_CLASS = `${BLOCK}__popup--visible`;
  const SUBMIT_LOADING_CLASS = `${BLOCK}__submit--loading`;
  const PENDING_KEY = `${BLOCK}:pending`;
  const TRANSITION_MS = 300;

  /* Only one section may claim a `customer_posted=true` redirect per page load. */
  let redirectHandled = false;

  function readPending() {
    try {
      return sessionStorage.getItem(PENDING_KEY);
    } catch (error) {
      return null;
    }
  }

  function writePending(value) {
    try {
      if (value) sessionStorage.setItem(PENDING_KEY, value);
      else sessionStorage.removeItem(PENDING_KEY);
    } catch (error) {
    }
  }

  class TrustSubscribe {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector("[data-trust-subscribe-form] form");
      this.popup = root.querySelector("[data-trust-subscribe-popup]");

      if (!this.form || !this.popup) return;

      this.input = root.querySelector("[data-trust-subscribe-input]");
      this.submit = this.form.querySelector('[type="submit"]');
      this.closeButton = this.popup.querySelector("[data-trust-subscribe-popup-close]");
      this.hideTimer = null;
      this.isOpen = false;

      this.onSubmit = this.onSubmit.bind(this);
      this.onPopupClick = this.onPopupClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.form.addEventListener("submit", this.onSubmit);
      this.popup.addEventListener("click", this.onPopupClick);

      root.trustSubscribe = this;

      this.restore();
    }

    /* --- Submit ---------------------------------------------------------- */

    async onSubmit(event) {
      writePending(this.root.id);

      if (!window.fetch || !this.form.checkValidity()) return;

      event.preventDefault();
      this.setLoading(true);

      try {
        const response = await fetch(this.form.action, {
          method: "POST",
          headers: { Accept: "text/html" },
          body: new FormData(this.form),
        });

        if (!response.ok || (response.url || "").indexOf("customer_posted=true") === -1) {
          this.form.submit();
          return;
        }

        writePending(null);
        this.form.reset();
        this.open();
      } catch (error) {
        this.form.submit();
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(on) {
      if (!this.submit) return;

      this.submit.classList.toggle(SUBMIT_LOADING_CLASS, on);
      this.submit.disabled = on;
      this.submit.setAttribute("aria-busy", on ? "true" : "false");
    }

    /* --- Restore after a native form redirect ---------------------------- */

    restore() {
      if (redirectHandled) return;

      const params = new URLSearchParams(window.location.search);
      if (params.get("customer_posted") !== "true") return;

      const pending = readPending();
      if (pending && pending !== this.root.id) return;

      redirectHandled = true;
      writePending(null);
      this.cleanUrl(params);
      this.open();
    }

    cleanUrl(params) {
      if (!window.history || !window.history.replaceState) return;

      params.delete("customer_posted");
      params.delete("form_type");

      const query = params.toString();
      window.history.replaceState({}, "", window.location.pathname + (query ? `?${query}` : ""));
    }

    /* --- Popup ----------------------------------------------------------- */

    onPopupClick(event) {
      if (
        event.target.closest("[data-trust-subscribe-popup-close]") ||
        !event.target.closest(`.${BLOCK}__popup-dialog`)
      ) {
        this.close();
      }
    }

    onKeydown(event) {
      if (event.key === "Escape") this.close();
    }

    open() {
      if (this.isOpen) return;

      clearTimeout(this.hideTimer);
      this.isOpen = true;
      this.popup.hidden = false;

      requestAnimationFrame(() => {
        this.popup.classList.add(POPUP_VISIBLE_CLASS);
      });

      document.documentElement.style.overflow = "hidden";
      document.addEventListener("keydown", this.onKeydown);

      if (this.closeButton) this.closeButton.focus();
    }

    close() {
      if (!this.isOpen) return;

      this.isOpen = false;
      this.popup.classList.remove(POPUP_VISIBLE_CLASS);
      document.documentElement.style.overflow = "";
      document.removeEventListener("keydown", this.onKeydown);

      this.hideTimer = setTimeout(() => {
        this.popup.hidden = true;
      }, TRANSITION_MS);

      if (this.input) this.input.focus();
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll("[data-trust-subscribe]").forEach((root) => {
      if (!root.trustSubscribe) new TrustSubscribe(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
